document.addEventListener("DOMContentLoaded", function () {
  function updateButtonQty(qty, el) {
    el.parents("cc-quantity-picker")
      .siblings("button")
      .attr("data-variant-qty", qty);
  }

  $(document).on(
    "click",
    ".cc-pgi-productitem--info .cc-pgi-variant-selector button",
    function () {
      let varId = $(this).data("variant-id");
      let varPrice = $(this).data("price");
      let varComparePrice = $(this).data("compare-price");
      let varSku = $(this).data("sku");
      let avail = $(this).data("available");
      let qty = $(this).data("quantity");
      let image = $(this).data("image");
      let buttonText = "";
      console.log(image);

      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings(".cc-pgi-form-container")
        .find("button")
        .show();

      if (qty <= 0 && avail == true) {
        buttonText = "Pre-order";
      } else if (qty <= 0 && avail == false) {
        buttonText = "Out of Stock";
        $(this)
          .parents(".cc-pgi-variant-selector")
          .siblings(".cc-pgi-form-container")
          .find("button")
          .hide();
      } else {
        buttonText = "Add to cart";
      }

      $(this)
        .parents(".cc-pgi-variant-selector")
        .find("button.cc-variant-active")
        .removeClass("cc-variant-active");

      $(this).addClass("cc-variant-active");

      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings("a")
        .find(".sku")
        .html(varSku);
      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings("a")
        .find(".price")
        .html(varPrice);
      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings("a")
        .find(".compare-price")
        .html(varComparePrice);
      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings(".cc-pgi-form-container")
        .find("button")
        .attr("data-variant-id", varId);

      $(this)
        .parents(".cc-pgi-variant-selector")
        .siblings(".cc-pgi-form-container")
        .find("button .atc-text")
        .html(buttonText);

      $(this).parents(".productitem__container").find("figure > img").attr({
        src: image,
        srcset: image,
      });
    }
  );

  $(document).on("click", "cc-quantity-picker .icon", function () {
    let curVal = parseInt(
      $(this).parents("cc-quantity-picker").find("input").val()
    );
    let curFunc = $(this).attr("data-function");

    if (curVal >= 1 && curFunc == "add") {
      $(this)
        .parents("cc-quantity-picker")
        .find("input")
        .val(curVal + 1);
      updateButtonQty(curVal + 1, $(this));
    } else if (curVal > 1 && curFunc == "subtract") {
      $(this)
        .parents("cc-quantity-picker")
        .find("input")
        .val(curVal - 1);
      updateButtonQty(curVal - 1, $(this));
    } else {
    }
  });

  $(document).on("change", "cc-quantity-picker input", function () {
    let curVal = $(this).val();
    updateButtonQty(curVal, $(this));
  });
});
